module.exports = __webpack_public_path__ + "static/img/gxg4.40bfec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg4.png
// module id = Q5sA
// module chunks = 2